import { render } from "./SustainabilityJumpToNav.vue?vue&type=template&id=3f9c0f38&scoped=true"
import script from "./SustainabilityJumpToNav.vue?vue&type=script&lang=js"
export * from "./SustainabilityJumpToNav.vue?vue&type=script&lang=js"

import "./SustainabilityJumpToNav.vue?vue&type=style&index=0&id=3f9c0f38&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9c0f38"]])

export default __exports__